import {Box, Flex, Icon, Image} from '@chakra-ui/react'
import {
  updateIsShowModalExitFlow,
  updateIsShowReportErrorForm,
} from '@redux/shared/shared'
import {useDispatch, useSelector} from 'react-redux'
import {ReactComponent as ExclamationCircle} from '@assets/svgs/exclamation-circle.svg'
import Close from '@assets/svgs/close.svg'
import {useLocation} from 'react-router-dom'
import {updateIsShowConfirmClose} from '@redux/gym/gymSlice'
import {getFeedbackExitFlowType} from '@utils'
import Progress from './Progress'
import {useEffect, useState} from 'react'

const Header = ({steps, currentContent}: {steps: any; currentContent: any}) => {
  const {entry_point} = useLocation()?.state || {}
  const {dataFeedbackOverview} = useSelector((state: any) => state.shared)
  const [currentStepIndex, setCurrentStepIndex] = useState(0)
  const dispatch = useDispatch()

  useEffect(() => {
    if (steps && currentContent?.progress) {
      const index = steps?.findIndex(
        (item: any) => item === currentContent?.progress,
      )
      setCurrentStepIndex(index !== -1 ? index : 0)
    }
  }, [currentContent, steps])

  const handleClickClose = () => {
    if (
      entry_point === 'ROADMAP' &&
      !dataFeedbackOverview?.feedback_data[
        getFeedbackExitFlowType(location.pathname)
      ]?.is_completed
    ) {
      dispatch(updateIsShowModalExitFlow(true))
    } else {
      dispatch(updateIsShowConfirmClose(true))
    }
  }

  return (
    <Box height={'60px'}>
      <Flex
        h={'100%'}
        w={'100%'}
        alignItems={'center'}
        gap={'32px'}
        maxWidth={'1280px'}
        margin={'0 auto'}>
        <Image src={Close} onClick={handleClickClose} cursor={'pointer'} />
        <Progress
          steps={steps}
          currentIndex={currentStepIndex}
          currentPercent={0}
          px={'16px'}
        />
        <Icon
          w={'24px'}
          h="24px"
          viewBox="0 0 24 24"
          cursor={'pointer'}
          sx={{
            path: {
              fill: '#000000',
            },
          }}
          onClick={() => {
            dispatch(updateIsShowReportErrorForm(true))
          }}>
          <ExclamationCircle />
        </Icon>
      </Flex>
    </Box>
  )
}

export default Header
